import React from 'react';
import { PageLayout } from '../shared/PageLayout';
import { GovernanceRulesTab } from '../../../governance/tabs/GovernanceRulesTab';
export function ValidationRulesPage() {
  return <PageLayout title="Validatieregels" subtitle="Regelcatalogus, regelboeken per module en drempelwaarden" breadcrumbs={[{
    label: 'Content & Kwaliteit'
  }, {
    label: 'Validatieregels'
  }]} data-id="element-456">
      <GovernanceRulesTab data-id="element-457" />
    </PageLayout>;
}